import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';

import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';
import { t, parseDateString } from '~/helpers';

import { Modal } from '~/components';

import history from '~/services/history';

import { TypeFilters } from '~/components';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  Select,
} from '~/components/Form';

import { isEmpty, isNull, isNumber } from 'lodash';
import * as Yup from 'yup';

import { resetParams } from '~/store/modules/hooks/actions';

import api from '~/services/api';

import { default as FormRelAbastecimento } from './FormRelAbastecimento';

function DlgRelFormSub() {
  const [open, setOpen] = useState(true);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const formRelAbastecimentoRef = useRef(null);
  const reference = useRef(null);

  const [tiposAgenda, setTiposAgenda] = useState([]);

  const [showForm, setShowForm] = useState(false);

  const [valor_muni_codigo, setValor_muni_codigo] = useState('');
  const [valor_tiag_nome, setValor_tiag_nome] = useState('');
  const [muLocalidade, setMuLocalidade] = useState({
    mula_codigo: '',
    mula_desc_localidade: '',
  });

  const data = useSelector((state) => state.servicedlgrelestoque);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );
  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  //Variáveis temporárias
  const [tempDatahorainicial, setTempDatahorainicial] = useState(
    datahorainicial
  );
  const [tempDatahorafinal, setTempDatahorafinal] = useState(datahorafinal);
  const [tempTiag_codigo, setTempTiag_codigo] = useState('');
  const [tempVeic_placa, setTempVeic_placa] = useState('');
  const [tempAgen_codigo, setTempAgen_codigo] = useState('');
  const [tempMuni_codigo, setTempMuni_codigo] = useState('');
  const [tempMuLocalidade, setTempMuLocalidade] = useState({
    mula_codigo: '',
    mula_desc_localidade: '',
  });
  const [tempOrgao, setTempOrgao] = useState({
    veic_orga_codigo: '',
    orga_nome: '',
  });

  function handleSerializeForm(params) {

    if (params.tipo == 'tela') {
      let data = {
        ...params,
        mula_codigo: muLocalidade.mula_codigo ?? '',
        mula_desc_localidade: muLocalidade.mula_desc_localidade ?? '',
        tiag_nome: valor_tiag_nome,
        orga_nome: tempOrgao.orga_nome,
      };

      handleDispatch(data);

      setOpen(false);
    } else {
      return {
        ...params,
        mula_codigo: muLocalidade.mula_codigo ?? '',
        mula_desc_localidade: muLocalidade.mula_desc_localidade ?? '',
        tiag_nome: valor_tiag_nome,
        orga_nome: tempOrgao.orga_nome,
      };
    }

    setTempDatahorainicial(params.datahorainicial);
    setTempDatahorafinal(params.datahorafinal);
    setTempTiag_codigo(params.tiag_codigo ?? '');
    setTempVeic_placa(params.veic_placa ?? '');
    setTempAgen_codigo(params.agen_codigo ?? '');
    setTempMuni_codigo(params.muni_codigo ?? '');
    setTempMuLocalidade(
      muLocalidade.mula_codigo
        ? {
          mula_codigo: muLocalidade.mula_codigo,
          mula_desc_localidade: muLocalidade.mula_desc_localidade,
        }
        : { mula_codigo: '', mula_desc_localidade: '' }
    );
    setTempOrgao(
      params.veic_orga_codigo
        ? {
          veic_orga_codigo: params.veic_orga_codigo,
          orga_nome: params.orga_nome,
        }
        : { veic_orga_codigo: '', orga_nome: '' }
    );
  }

  useEffect(() => {
    async function buscaTiposAgenda() {
      let response = await api.get(`tipoagenda/tipo`);
      if (!isEmpty(response.data)) {
        let opts = [];
        opts.push({ value: null, label: 'TODOS' });
        response.data.map((value) => {
          opts.push({ value: value.tiag_codigo, label: value.tiag_nome });
        });
        setTiposAgenda(opts);
      } else {
        setTiposAgenda([]);
      }
    }
    buscaTiposAgenda();
  }, []);

  const handleValidate = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(datahorafinal, `A data não pode ser superior a ${datahorafinal}`)
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
      });

      await schema.validate(data, { abortEarly: false });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }, []);

  function configuraNomeTipoAgenda(codigo) {
    let nome = '';
    tiposAgenda.map((tipo) => {
      if (!isNull(codigo) && tipo.value === codigo) {
        nome = tipo.label;
      }
    });
    setValor_tiag_nome(nome);
  }

  const handleDispatch = useCallback(async (params) => {
    setShowForm(true);
    formRelAbastecimentoRef.current.handleOpenModal({ params: params });
  });


  useEffect(() => {
    if (open) {
      dispatch(resetParams());
    } else {
      if (!showForm) {
        history.push('/dlgRelDiagUnidata.swf');
      }
    }
  }, [open, showForm]);


  const handleReopenForm = useCallback(() => {
    setOpen(true);
    setShowForm(false);
  }, []);

  const handleGetDatat = useCallback((value) => {
    console.log('handleGetDatat', value);
  }, []);


  return (
    <>
      <Report
        ref={reference}
        open={open}
        onClose={() => setOpen(false)}
        title="dlgrelformsub TESTE"
        relatorio="FILTRORELACOMPAATENDIMENTO"
        validate={handleValidate}
        serialize={(param) => handleSerializeForm(param)}
        initials={{
          datahorainicial: tempDatahorainicial,
          datahorafinal: tempDatahorafinal,
          tiag_codigo: tempTiag_codigo,
          veic_placa: tempVeic_placa,
          agen_codigo: tempAgen_codigo,
          muni_codigo: tempMuni_codigo,
          veic_orga_codigo: tempOrgao.veic_orga_codigo,
          orga_nome: tempOrgao.orga_nome,
          mula_codigo: tempMuLocalidade.mula_codigo,
          mula_desc_localidade: tempMuLocalidade.mula_desc_localidade
        }}
      >
        <DateTime
          label="Data Inicial"
          name="datahorainicial"
          serialize={(value) =>
            moment(value)
              .set({ hour: 0, minute: 0, second: 0 })
              .format('DD/MM/YYYY HH:mm:ss')
          }
        />

        <DateTime
          label="Data Final"
          name="datahorafinal"
          serialize={(value) =>
            moment(value)
              .set({ hour: 23, minute: 59, second: 59 })
              .format('DD/MM/YYYY HH:mm:ss')
          }
        />

        <TypeFilters
          name="filtroData"
          numberOfYears={9}
          options={[{ label: t('s.geral.filtro.periododatahora'), value: 1 },
          { label: t('s.geral.filtro.periododatahora'), value: 2 }]}


          onCallback={handleGetDatat}
          initialURL="/turno/getturnosinicio"
          finalURL="/turno/getturnosfim"
          code="ELE"
        />


        <Input name="veic_placa" label="Placa do Veículo" />

        <Input name="agen_codigo" label="Número Agenda" type="number" />

        <Select
          name="tiag_codigo"
          label="Tipo de Agenda"
          options={tiposAgenda.map((op) => ({
            label: op.label,
            value: op.value,
          }))}
          getValue={(value) => {
            configuraNomeTipoAgenda(value);
          }}
        />

        <Autocomplete
          name="muni_codigo"
          label="muni_nome"
          title="Município"
          id="muni_codigo"
          url="municipio"
          unique="muni_codigo"
          hiddens={[{ name: 'muni_nome' }]}
          getValue={(value) => {
            if (tempMuLocalidade.mula_codigo) {
              setMuLocalidade({
                mula_codigo: tempMuLocalidade.mula_codigo,
                mula_desc_localidade: tempMuLocalidade.mula_desc_localidade,
              });
              setTempMuLocalidade({
                mula_codigo: '',
                mula_desc_localidade: '',
              });
            } else {
              setMuLocalidade({ mula_codigo: '', mula_desc_localidade: '' });
            }

            if (value.muni_codigo !== null) {
              setValor_muni_codigo(value.muni_codigo);
            } else {
              setValor_muni_codigo(0);
            }
          }}
        />

        <Autocomplete
          includeInputInList
          disabledItemsFocusable
          disableClearable={!muLocalidade.mula_codigo}
          name="mula_codigo"
          label="mula_desc_localidade"
          title="Localidade"
          id="mula_codigo"
          url="municipiolocalatendimento/municipiolocalatendimentosimples"
          unique="mula_codigo"
          hiddens={[{ name: 'mula_desc_localidade' }]}
          getValue={(value) => {
            isNull(value.mula_desc_localidade)
              ? setMuLocalidade({ mula_codigo: '', mula_desc_localidade: '' })
              : setMuLocalidade(value);
          }}
          inputValue={muLocalidade.mula_desc_localidade}
          onInputChange={(e, value) => {
            if (e && e.type != 'blur') {
              let obj = {
                ...muLocalidade,
                mula_desc_localidade: value,
              };
              setMuLocalidade(obj);
            }
          }}
          disabled={valor_muni_codigo == 0 ? true : false}
          params={{
            wherefield: ['muni_codigo'],
            valuewherefield: [valor_muni_codigo],
            typewherefield: ['EQUALS'],
          }}
        />

        <Autocomplete
          name="veic_orga_codigo"
          label="orga_nome"
          title="Órgão"
          id="veic_orga_codigo"
          url="orgao"
          unique="orga_codigo"
          // defaultValue=""
          getValue={(value) => {
            value.orga_codigo
              ? setTempOrgao({
                veic_orga_codigo: value.orga_codigo,
                orga_nome: value.orga_nome,
              })
              : setTempOrgao({
                veic_orga_codigo: '',
                orga_nome: '',
              });
          }}
          hiddens={[{ name: 'orga_nome' }]}
        />

        <RadioGroup
          name="tipo"
          label="Formato"
          options={[
            { label: 'PDF', value: 'pdf' },
            { label: 'Excel', value: 'xls' },
            { label: 'Tela', value: 'tela' },
          ]}
          defaultValue="tela"
          serialize={(value) => value}
          row
        />
      </Report>

      {showForm && (
        <>

        </>
      )}

      <Modal
        ref={formRelAbastecimentoRef}
        disableBackdropClick
        disableEscapeKeyDown
        component={FormRelAbastecimento}
        title="Relatorio de Abastecimento"
        loading={loading}
        maxWidth="xl"
        form
        // actions={[
        //   {
        //     label: t('s.geral.botaofechar'),
        //     callback: () => formRelAbastecimentoRef.current.handleCloseModal(),
        //     color: 'secondary',
        //   },
        // ]}
        onClose={() => handleReopenForm()}
        pdf
        xls
      />



    </>
  );
}

export default DlgRelFormSub;
